import { defineMessages } from "react-intl";

export const messages = defineMessages({
  assignCategoryDialogLabel: {
    id: "8hrH/z",
    defaultMessage: "Search Category",
    description: "dialog header",
  },
  assignCategoryDialogPlaceholder: {
    id: "sf6FMK",
    defaultMessage: "Search by category name, etc...",
    description: "dialog search placeholder",
  },
  assignCategoryDialogHeader: {
    id: "sW9IyX",
    defaultMessage: "Assign Category",
    description: "dialog header",
  },
  confirmButton: {
    id: "XLYssG",
    defaultMessage: "Assign and save",
    description: "assign categories to sale and save",
  },
});
